var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "controls",
    },
    [
      _c("div", [
        !_vm.module.mandatory
          ? _c("label", [
              _c("input", {
                ref: "checkbox_" + _vm.module.id,
                attrs: {
                  type: "checkbox",
                },
                domProps: {
                  checked: _vm.module.active,
                },
                on: {
                  click: function click($event) {
                    return _vm.toggleModuleActivation(_vm.module)
                  },
                },
              }),
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.module.active
                      ? _vm.$gettext("Werkzeug ist aktiv")
                      : _vm.$gettext("Werkzeug ist inaktiv")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.module.active && !_vm.module.mandatory
          ? _c(
              "a",
              {
                staticClass: "toggle_visibility",
                attrs: {
                  href: "#",
                  role: "checkbox",
                  "aria-checked":
                    _vm.module.visibility !== "tutor" ? "true" : "false",
                },
                on: {
                  click: function click($event) {
                    $event.preventDefault()
                    return _vm.toggleModuleVisibility(_vm.module)
                  },
                },
              },
              [
                _c("studip-icon", {
                  staticClass: "text-bottom",
                  attrs: {
                    shape:
                      _vm.module.visibility !== "tutor"
                        ? "visibility-visible"
                        : "visibility-invisible",
                    title: _vm.$gettextInterpolate(
                      _vm.$gettext(
                        "Inhaltsmodul %{ name } für Teilnehmende unsichtbar bzw. sichtbar schalten"
                      ),
                      {
                        name: _vm.module.displayname,
                      },
                      true
                    ),
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }